import React from "react";
import { Route, Switch } from "react-router-dom";
import Home from "./containers/Home";
import Notes from "./containers/Notes";
import Login from "./containers/Login";
import Signup from "./containers/Signup";
import Settings from "./containers/Settings";
import NewNote from "./containers/NewNote";
import ResetPassword from "./containers/ResetPassword";
// import Feedback from "./containers/Feedback";
import About from "./containers/About";
import Privacy from "./containers/Privacy";
import NotFound from "./containers/NotFound";
import AppliedRoute from "./components/AppliedRoute";
import AuthenticatedRoute from "./components/AuthenticatedRoute";
import UnauthenticatedRoute from "./components/UnauthenticatedRoute";

export default ({ childProps }) =>
  <Switch>
    <AppliedRoute path="/" exact component={Home} props={childProps} />
    <UnauthenticatedRoute path="/login" exact component={Login} props={childProps} />
    <UnauthenticatedRoute path="/signup" exact component={Signup} props={childProps} />
    {/* <AppliedRoute path="/feedback" exact component={Feedback} props={childProps} /> */}
    <AppliedRoute path="/about" exact component={About} props={childProps} />
    <AppliedRoute path="/privacy" exact component={Privacy} props={childProps} />
    <AuthenticatedRoute path="/settings" exact component={Settings} props={childProps} />
    <AuthenticatedRoute path="/notes/new" exact component={NewNote} props={childProps} />
    <UnauthenticatedRoute path="/login/reset" exact component={ResetPassword} props={childProps} />
    <AppliedRoute path="/notes/:id" exact component={Notes} props={childProps} />
    <AppliedRoute path="/:view" exact component={Home} props={childProps} />
    { /* Finally, catch all unmatched routes */ }
    <Route component={NotFound} />
  </Switch>;
